import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Pagination } from "swiper";

import edit from "../../assets/images/icon/edit-green.svg";
import editBlue from "../../assets/images/icon/edit-blue.svg";
import editGreen from "../../assets/images/icon/edit-light-green.svg";
import DogPaw from "../../assets/images/icon/DogPaw";
import book from "../../assets/images/icon/book.svg";
import alarm from "../../assets/images/icon/alarm.svg";
import alarmGreen from "../../assets/images/icon/alarm-green.svg";
import dogFace from "../../assets/images/icon/dogFace.svg";
import catFace from "../../assets/images/icon/catFace.svg";
import add from "../../assets/images/icon/add-green.svg";
import CustomSwitch from "../../components/button/CustomSwitch";
import CookieSettingGreenPopup from "../../components/popup/CookieSettingGreenPopup";
import TopBanner from "../../components/layout/TopBanner";
import { SearchId } from "../../services/SearchId";
// import { tempLineId1 } from "../../services/Api";
import {
  postUpdatePet,
  SearchPetDetail,
  SearchPetOwnerProfile,
} from "../../services/Dogbook";
import getTime from "../../functions/getTime";
import { useLiff } from "react-liff";
import MemberCard from "../../components/card/MemberCard";
import TopLogoCat from "../../components/layout/TopLogoCat";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setStampInviteFriend } from "../../features/invite/StampInviteFriendSlice";
import CustomSwitchGreen from "../../components/button/CustomSwitchGreen";
import NotificationMainCat from "../catbook/Notification";
import { useSearchParams } from "react-router-dom";

export default function CatBook() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const page = searchParams.get('page') || 1;
  console.log("page >>", page);
  //ช้อมูลผู้ใช้ - info/ สมุดที่อยู่ - address
  let [infoData, setInfoData] = useState("info");
  let [topMenu, setTopMenu] = useState("data");
  let [ownerProfile, setOwnerProfile] = useState(null);
  let [pet, setPet] = useState(null);

  // popup
  let [openCookiePopup, setOpenCookiePopup] = useState(false);
  let [openTooltip, setOpenTooltip] = useState(true);


  const { liff } = useLiff();
  const lineId = liff.getDecodedIDToken().sub;


  useEffect(() => {
    getSearchId();
    //
  }, []);

  async function getSearchId() {
    return await SearchId({
      params: { lineId: lineId || null, species: 2 },
    })
      .then(async (response) => {
        if (!response.data.body.memberId) {
          navigate("/register-cat");
        } else {
          if (page == 3) {
            setTopMenu("schedule")
          }
          getOwnerProfile(response.data.body.memberId);
          getPet(response.data.body.memberId);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getOwnerProfile(member_id) {
    return await SearchPetOwnerProfile({
      params: { lineId: lineId || null, species: 2 },
      member_id: member_id,
    })
      .then(async (response) => {
        setOwnerProfile(response.data.body);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getPet(member_id) {
    return await SearchPetDetail({
      params: { lineId: lineId || null, species: 2 },
      member_id: member_id,

    })
      .then(async (response) => {
        if (response.data.resultCode === 20000) {
          setPet(response.data.body);
          console.log(response.data.body)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function postUpdatePetNoti(petId, isNoti) {
    const payload = { petId: petId, isNoti: isNoti };
    try {
      const { data } = await postUpdatePet({ data: payload });
      console.log("resData.data >>", data);
      if (data.resultCode === 20000) {
        console.log("resData.data >>", data.body);
        getSearchId();
      }
    } catch (error) {
      console.log("createPetOwnerRegister error", error);
    }
  }

  function UserInfo(title, data) {
    return (
      <div className="flex justify-between items-start">
        <p className="text-gray text-[20px] whitespace-pre-line leading-[24px]">
          {title}:
        </p>
        {data ? (
          <p className="max-w-[200px] text-right text-darkGray text-[20px] whitespace-pre-line leading-[24px]">
            {data}
          </p>
        ) : (
          <p className="text-darkGray text-[20px]">-</p>
        )}
      </div>
    );
  }

  const PetCarousal = () => {
    return (
      <Swiper
        spaceBetween={13}
        // slidesPerView={1.08}
        pagination={true}
        modules={[Pagination]}
        scrollbar={{ draggable: true }}
      >
        {pet &&
          pet.map((item, i) => (
            item.species === 1 ?
              <SwiperSlide key={i}>
                <div className="bg-white rounded-[4px] relative pt-[68px] mt-[55px]">
                  {item.urlPicture ? (
                    <img
                      className="absolute top-[-50px] left-0 right-0 mx-auto rounded-full w-[118px] h-[118px] object-cover"
                      src={
                        item.urlPicture.startsWith("data:image/png;base64")
                          ? item.urlPicture
                          : `data:image/png;base64,${item.urlPicture}`
                      }
                      alt=""
                    />
                  ) : (
                    <div className="absolute top-[-50px] left-0 right-0 mx-auto rounded-full h-[118px] w-[118px] bg-blueGray flex justify-center items-center">
                      <img className="w-[60px]" src={dogFace} alt="" />
                    </div>
                  )}

                  <div className="p-[16px]">
                    <div className="flex justify-between">
                      <p className="text-[24px] text-lightBlue">ข้อมูลน้องหมา</p>
                      <button
                        onClick={() => navigate(`/catbook-edit-dog/${item.petId}`)}
                        className="w-[90px] flex gap-[5px] items-center justify-center py-[2px] px-[12px] rounded-[28px] border-[1px] border-lightBlue"
                        style={{ backgroundColor: '#EAF1FC' }}
                      >
                        <img className="w-[14px]" src={editBlue} alt="" />
                        <p className="text-lightBlue text-[16px] whitespace-nowrap">
                          แก้ไขข้อมูล
                        </p>
                      </button>
                    </div>
                    <div className="flex flex-col gap-[8px] mt-[10px]">
                      {UserInfo("ชื่อน้องหมา", item.petName)}
                      {item.dogBreed ? (
                        <span>{UserInfo("สายพันธุ์", item.dogBreed.name)}</span>
                      ) : (
                        <span>{UserInfo("สายพันธุ์", "-")}</span>
                      )}
                      {UserInfo(
                        "วันเกิด",
                        getTime.getFullTimeString(item.birthday)
                      )}
                      {UserInfo("อายุ", `${getTime.getYearRange(item.birthday)}`)}
                      {UserInfo(
                        "น้ำหนัก",
                        `${parseInt(item.weight).toFixed(0)} กิโลกรัม`
                      )}
                    </div>

                    <div className="flex items-center gap-[12px]">
                      <button
                        onClick={() => navigate(`/pet-diary?petId=${item.petId}`)}
                        className="bg-blue mt-[20px] w-full flex gap-[5px] items-center justify-center py-[4px] rounded-[28px] border-[1px] border-blue"
                      >
                        <img className="w-[14px]" src={book} alt="" />
                        <p className="text-white text-[20px]">บันทึกประจำวัน</p>
                      </button>
                    </div>



                    {/* <div>
                  <p className="text-gray text-[20px]">
                    ตั้งเวลาแจ้งเตือนพบคุณหมอ:
                  </p>

                  <div className="flex items-center justify-between">
                    <div className="flex justify-start items-start gap-[10px]">
                      <img className="mt-[7px] w-[20px]" src={alarm} alt="" />
                      <div>
                        <p className="text-blue font-medium text-[24px]">
                          {getTime.getFullTimeString(item.lastDateProduct)}
                        </p>
                        <p className="text-gray text-[14px]">
                          วันที่นัดพบคุณหมอ:{" "}
                          {getTime.getFullTimeString(item.lastDateProduct)}
                        </p>
                      </div>
                    </div>

                    <CustomSwitch
                      checked={item.isNoti}
                      handleFunction={() => {
                        postUpdatePetNoti(item.petId, !item.isNoti);
                      }}
                    />
                  </div>

                  <button
                    onClick={() => navigate("/dogbook-edit-noti")}
                    className="mt-[20px] flex justify-center items-center bg-lightBlue2 rounded-[28px] w-full gap-[10px] py-[8px]"
                  >
                    <img className="w-[20px]" src={alarm} alt="" />
                    <p className="text-[24px] text-blue text-center">
                      ตั้งเวลาแจ้งเตือนพบคุณหมอ
                    </p>
                  </button>
                </div> */}
                  </div>
                </div>
              </SwiperSlide>
              :
              <SwiperSlide key={i}>
                <div className="bg-white rounded-[4px] relative pt-[68px] mt-[55px]">
                  {item.urlPicture ? (
                    <img
                      className="absolute top-[-50px] left-0 right-0 mx-auto rounded-full w-[118px] h-[118px] object-cover"
                      src={
                        item.urlPicture.startsWith("data:image/png;base64")
                          ? item.urlPicture
                          : `data:image/png;base64,${item.urlPicture}`
                      }
                      alt=""
                    />
                  ) : (
                    <div className="absolute top-[-50px] left-0 right-0 mx-auto rounded-full h-[118px] w-[118px] bg-greenGray flex justify-center items-center">
                      <img className="w-[60px]" src={catFace} alt="" />
                    </div>
                  )}

                  <div className="p-[16px]">
                    <div className="flex justify-between">
                      <p className="text-[24px] text-lightGreen">ข้อมูลน้องแมว</p>
                      <button
                        onClick={() => navigate(`/catbook-edit/${item.petId}`)}
                        className="w-[90px] flex gap-[5px] items-center justify-center py-[2px] px-[12px] rounded-[28px] border-[1px] border-lightGreen"
                        style={{ backgroundColor: '#EDF8F1' }}
                      >
                        <img className="w-[14px]" src={editGreen} alt="" />
                        <p className="text-lightGreen text-[16px] whitespace-nowrap">
                          แก้ไขข้อมูล
                        </p>
                      </button>
                    </div>
                    <div className="flex flex-col gap-[8px] mt-[10px]">
                      {UserInfo("ชื่อน้องแมว", item.petName)}
                      {item.dogBreed ? (
                        <span>{UserInfo("สายพันธุ์", item.dogBreed.name)}</span>
                      ) : (
                        <span>{UserInfo("สายพันธุ์", "-")}</span>
                      )}
                      {UserInfo(
                        "วันเกิด",
                        getTime.getFullTimeString(item.birthday)
                      )}
                      {UserInfo("อายุ", `${getTime.getYearRange(item.birthday)}`)}
                      {UserInfo(
                        "น้ำหนัก",
                        `${parseInt(item.weight).toFixed(0)} กิโลกรัม`
                      )}
                    </div>

                    <div className="flex items-center gap-[12px]">
                      <button
                        onClick={() => navigate(`/cat-diary?petId=${item.petId}`)}
                        className="bg-green mt-[20px] w-full flex gap-[5px] items-center justify-center py-[2px] px-[24px] rounded-[28px] border-[1px] border-green"
                      >
                        <img className="w-[14px]" src={book} alt="" />
                        <p className="text-white text-[20px]">บันทึกประจำวัน</p>
                      </button>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
          ))}
      </Swiper>
    );
  };

  const onInvite = (e) => {
    console.log("e >>", e.target.id);
    console.log("e >>", e.target.className);
    console.log("e >>", e.target);

    dispatch(setStampInviteFriend({ memberCode: ownerProfile.memberCode }));
    if (e.target.id === "tooltipExit") {
      setOpenTooltip(false);
      localStorage.setItem("show-tooltip ", "1");
    } else if (e.target.className === "bBtnInvite") {
      navigate("/catbook-invite-friend");
    }
  };

  useEffect(() => {
    let showTooltip = localStorage.getItem("show-tooltip ");
    console.log("showTooltip >>", showTooltip);
    console.log(pet)
    if (showTooltip) {
      setOpenTooltip(false);
    } else {
      setOpenTooltip(true);
    }
  }, []);

  return (
    <>
      <CookieSettingGreenPopup
        open={openCookiePopup}
        onClose={() => {
          setOpenCookiePopup(false);
        }}
      />
      <div id="catbook-page">
        <TopLogoCat />
        <TopBanner type="catbook" />
        <div id="catbook" className="gradientBg mt-[-20px]">
          <div className="relative">
            <MemberCard data={ownerProfile} showTierBar={false} isCat={true}/>
            <div className="p-[10px]" style={{ backgroundColor: '#F2F2F2' }}>
              {/* <div id="inviteFriendBanner" onClick={onInvite}>
              <i className="iRibbon"></i>
              <p className="tInvite">
                ชวนเพื่อน 10 คน
                <br />
                เพื่อรับ Coin ไปเลย!
              </p>
              <button className="bBtnInvite">
                <div
                  id="tooltipInviteFriend"
                  data-show={`${openTooltip}`}
                  onClick={onInvite}
                >
                  <i className="bExit" id="tooltipExit"></i>
                  <div className="tTitle">
                    ชวนเพื่อนมาเป็นสมาชิก
                    <br />
                    รับ Coin ไปเลย!
                  </div>
                  <p>
                    เพียงชวนเพื่อนมาเป็นสมาชิกกับเราผ่านการแชร์ลิงก์เชิญให้เพื่อน
                    เมื่อครบ 10 คน คุณได้สิทธิ์แลก Coin ทันทีจาก One And Done
                    ไปเลย!
                  </p>
                </div>
                <i className="bBtnInvite"></i>
                <p className="bBtnInvite">ชวนเพื่อน</p>
              </button>
            </div> */}

              {/* เมนูใหม่ด้านบน */}
              <div className="rounded-[28px] border border-green w-[351px] h-[48px] flex items-center justify-center mx-auto" style={{ backgroundColor: '#EAF6EF' }}>
                <div className="flex items-center p-[4px] w-full">
                  <button
                    onClick={() => setTopMenu("data")}
                    className={
                      `flex-1 text-[20px] text-center py-[8px] rounded-[24px] transition-all duration-200 flex items-center justify-center h-[40px] ` +
                      (topMenu === "data"
                        ? "bg-green text-white"
                        : "text-green")
                    }
                  >
                    ข้อมูลของฉัน
                  </button>
                  <button
                    onClick={() => setTopMenu("pets")}
                    className={
                      `flex-1 text-[20px] text-center py-[8px] rounded-[24px] transition-all duration-200 flex items-center justify-center h-[40px] ` +
                      (topMenu === "pets"
                        ? "bg-green text-white"
                        : "text-green")
                    }
                  >
                    สมุดพกสัตว์เลี้ยง
                  </button>
                  <button
                    onClick={() => setTopMenu("schedule")}
                    className={
                      `flex-1 text-[20px] text-center py-[8px] rounded-[24px] transition-all duration-200 flex items-center justify-center h-[40px] ` +
                      (topMenu === "schedule"
                        ? "bg-green text-white"
                        : "text-green")
                    }
                  >
                    ตารางนัดหมาย
                  </button>
                </div>
              </div>
            </div>


            <div className="p-[24px] relative">

              {topMenu === "data" && (
                <div className="bg-white rounded-[4px]">
                  <div className="flex items-center">
                    <p
                      onClick={() => setInfoData("info")}
                      className={
                        `w-full text-[20px] text-gray text-center py-[9px] border-b-[1px] border-lightGray ` +
                        (infoData === "info" &&
                          "!text-green !border-b-[4px] !border-green")
                      }
                    >
                      ข้อมูลผู้ใช้
                    </p>
                    <p
                      onClick={() => setInfoData("address")}
                      className={
                        `w-full text-[20px] text-gray text-center py-[9px] border-b-[1px] border-lightGray ` +
                        (infoData === "address" &&
                          "!text-green !border-b-[4px] !border-green")
                      }
                    >
                      สมุดที่อยู่
                    </p>
                  </div>

                  {infoData === "info" && ownerProfile ? (
                    <div className="p-[16px]">
                      <p className="text-[24px] text-lightGreen">ข้อมูลผู้ใช้</p>
                      <div className="flex flex-col gap-[8px] mt-[10px]">
                        {UserInfo("รหัสสมาชิก", ownerProfile.memberCode)}
                        {UserInfo(
                          "Coin สะสมรวม",
                          `${ownerProfile?.tierTotalPoints ?? 0} คะแนน`
                        )}
                        {UserInfo(
                          "Coin แลกสิทธิ์",
                          `${ownerProfile?.currentPoint ?? 0} คะแนน`
                        )}
                        {UserInfo(
                          "ชื่อ - นามสกุล",
                          `${ownerProfile.firstName} ${ownerProfile.lastName}`
                        )}
                        {UserInfo("อีเมล", ownerProfile.email)}
                        {UserInfo("เบอร์โทรศัพท์", ownerProfile.mobileNumber)}

                        {UserInfo(
                          "โรงพยาบาลสัตว์/\nคลินิกประจำ",
                          ownerProfile.favoriteHospital?.shopName ?? "-"
                        )}

                        {UserInfo(
                          "ร้านเพ็ทช็อปประจำ",
                          ownerProfile.favoriteShop?.shopName ?? "-"
                        )}

                        {UserInfo(
                          "ที่บ้านเลี้ยงแมวหรือไม่",
                          ownerProfile.isHaveCat ? "เลี้ยง" : "ไม่เลี้ยง"
                        )}
                      </div>

                      <button
                        onClick={() => navigate("/catbook-edit-info")}
                        className="mt-[20px] w-fit flex gap-[5px] items-center justify-center py-[2px] px-[24px] rounded-[28px] border-[1px] border-green"
                      >
                        <img className="w-[14px]" src={edit} alt="" />
                        <p className="text-green text-[20px]">แก้ไขข้อมูล</p>
                      </button>
                    </div>
                  ) : (
                    <div className="p-[16px]">
                      <p className="text-[24px] text-lightGreen">สมุดที่อยู่</p>

                      {ownerProfile && ownerProfile.address ? (
                        <div>
                          <div className="flex flex-col gap-[12px]">
                            <div>
                              <p className="text-[20px] text-gray">ที่อยู่:</p>
                              <p className="text-[20px]">
                                {ownerProfile.addressDetail}{" "}
                                {ownerProfile.address.addressName}
                              </p>
                            </div>

                            {ownerProfile.deAddress && (
                              <div>
                                <p className="text-[20px] text-gray">
                                  ที่อยู่จัดส่ง:
                                </p>
                                <p className="text-[20px]">
                                  {ownerProfile.deAddressDetail}{" "}
                                  {ownerProfile.deAddress.addressName}
                                </p>
                              </div>
                            )}
                          </div>

                          <button
                            onClick={() => navigate("/catbook-edit-info")}
                            className="mt-[20px] w-fit flex gap-[5px] items-center justify-center py-[2px] px-[24px] rounded-[28px] border-[1px] border-green"
                          >
                            <img className="w-[14px]" src={edit} alt="" />
                            <p className="text-green text-[20px]">แก้ไขข้อมูล</p>
                          </button>
                        </div>
                      ) : (
                        <div>
                          <p className="text-[20px]">
                            กรอกข้อมูลที่อยู่ของคุณเพื่อใช้ในการรับของรางวัล และรับ
                            สิทธิพิเศษต่างๆจาก One And Done
                          </p>

                          <button
                            onClick={() => navigate("/catbook-edit-info")}
                            className="mt-[20px] w-fit flex gap-[5px] items-center justify-center py-[2px] px-[24px] rounded-[28px] border-[1px] border-green"
                          >
                            <img className="w-[10px]" src={add} alt="" />
                            <p className="text-green text-[20px]">
                              เพิ่มข้อมูลที่อยู่
                            </p>
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {topMenu === "pets" && (
                <div className="bg-white rounded-[4px]">
                  <div className="p-[16px]">
                    <p className="text-lightGreen text-[28px] text-left">สมุดพกสัตว์เลี้ยง</p>

                    {pet && pet.length > 0 ? (
                      <PetCarousal />
                    ) : (
                      <div className="mt-[10px] flex justify-start items-start gap-[10px]">
                        <div>
                          <DogPaw width={17} color="#00693E" />
                        </div>
                        <p className="text-[20px] text-left leading-[20px]">
                          กรุณาเพิ่มข้อมูลสัตว์เลี้ยงของคุณ เพื่อรับสิทธิพิเศษต่างๆ
                          ของน้องหมา โดยกดที่ปุ่ม 'เพิ่มข้อมูลสัตว์เลี้ยง' ด้านล่าง
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {topMenu === "schedule" && (
                <NotificationMainCat />
              )}

              {topMenu === "data" && (
                <div className="flex justify-center">
                  <button
                    className="mt-[24px] text-white text-[24px] text-center py-[9px] px-[24px] bg-green/[0.24] rounded-[28px] border border-white"
                    onClick={() => setOpenCookiePopup(true)}
                  >
                    ตั้งค่านโยบายความเป็นส่วนตัวและคุกกี้
                  </button>
                </div>
              )}

            </div>
          </div>
        </div>
        {topMenu !== "schedule" &&
          <div
            id="add-btn"
            className="flex flex-col justify-center bg-white px-[20px] pt-[16px] pb-[24px]"
          >
            <button
              onClick={() => navigate("/catbook-add")}
              className="flex justify-center items-center bg-green rounded-[28px] w-full gap-[10px] py-[8px]"
            >
              <DogPaw width={20} color="#FFFFFF" />
              <p className="text-[24px] text-white text-center">
                เพิ่มข้อมูลสัตว์เลี้ยง
              </p>
            </button>
          </div>
        }
      </div>
    </>
  );
}
